import { Application } from "../../System/Application/Application";
import "./InteractiveCV.css";
import React, { useRef, useState, useLayoutEffect, useEffect } from "react";

import logo_up from "url:../../../assets/Logo-up.svg";
import glasgow_m1 from "url:../../../assets/glasgow_m1.pdf";
import reasearchlab_m1 from "url:../../../assets/researchlab_m1.pdf";
import tree_d_raycasting from "url:../../../assets/render.png";

const NOTES = {
    master: {
        img: logo_up,
        app: null,
        note: "reasearchLab2024",
        Fr: {
            title: "Master en Informatique",
            text: [
                "Après une licence en informatique à Poitiers, j'ai continué dans la même université en intégrant un master de recherche sélectif, spécialisé en Conception et Développement Logiciel.",
                "Ce master est dispensé par une École Universitaire de Recherche (EUR) et est axé sur la recherche en informatique, en mettant l'accent sur des matières telles que la data science, l'algorithmie 3D ou tout simplement l'anglais.",
                "Ce master m'a permis de réaliser plusieurs projets et stage de recherche, notamment en Machine Learning, en parallélisation et en algorithmie 3D.",
                "Je vous propose de découvrir un projet réalisé dans le cadre de l'unité d'enseignement \"Reasearch Lab\", où j'ai collaboré avec un doctorant de l'université de Poitiers, Maxime GAIDE, pour l'aide à lié son travail de recherche avec l'outil de modélisation Jerboa.",
            ],
        },
        En: {
            title: "Master in Computer Science",
            text: [
                "After obtaining a degree in computer science in Poitiers, I continued at the same university by enrolling in a selective research master's program, specializing in Software Design and Development.",
                "This master's is offered by a University Research School (EUR) and focuses on research in computer science, emphasizing subjects such as data science, 3D algorithms, or even English.",
                "This program allowed me to complete several projects and research internships, notably in Machine Learning, parallelization, and 3D algorithms.",
                "I invite you to explore a project carried out as part of the 'Research Lab' course, where I collaborated with a PhD student from the University of Poitiers, Maxime GAIDE, to integrate his research work with the Jerboa modeling tool.",
            ],
        },
    },
    licence: {
        img: logo_up,
        app: null,
        note: "xlim2023",
        Fr: {
            title: "Licence en Informatique",
            text: [
                "Mon parcours en informatique a débuté par une licence à l'Université de Poitiers, où j'ai obtenu mon diplôme avec mention Bien.",
                "Cette licence m'a permis d'acquérir des compétences solides en programmation, en algorithmie et en développement de logiciels.",
                "Durant ces années, j'ai suivi un cursus sélectif en ingénierie, ajoutant 20% d'enseignements supplémentaires : le Cursus Master en Ingénieurie (CMI). Ce cursus, en plus d'être accès sur l'informatique, l'est, aussi, sur des domaines plus variés comme, par exemple, la physique, l'électronique, les mathématiques ou encore le théâtre d'improvisation. De plus, ce cursus offre, chaque année, aux étudiants, des projets d'ampleur au sein du laboratoire de l'Université.",
                "Je vous propose donc de découvrir un projet réalisé dans le cadre du CMI en collaboration avec l'entreprise Einden, éditeure du logiciel Ephoto Dam.",
            ],
        },
        En: {
            title: "Bachelor of Computer Science",
            text: [
                "My journey in computer science began with a bachelor's degree at the University of Poitiers, where I graduated with honors.",
                "This program provided me with a solid foundation in programming, algorithms, and software development.",
                "During these years, I followed a selective engineering curriculum, adding 20% more courses: the Cursus Master en Ingénierie (CMI). This curriculum, in addition to being focused on computer science, also covers more varied fields such as physics, electronics, mathematics, and even improvisational theater. Furthermore, this curriculum offers students large-scale projects within the university's laboratory each year.",
                "I invite you to explore a project carried out as part of the 'Research Lab' course, where I collaborated with a PhD student from the University of Poitiers, Maxime GAIDE, to integrate his research work with the Jerboa modeling tool.",
            ],
        },
    },
    baccalaureat: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Baccalauréat général Scientifique",
            text: [
                "J'ai réalisé mon baccalauréat générale scientifique au Lycée de l'Image et du Son d'Angoulême. Pour moi, ce lycée a été un révélateur de mes passions. J'étudiais les sciences dans un lycée spécialisé dans l'audio-visuel. Parallèlement à ça, j'ai continué à me former en informatique sur mon temps libre, en autodidacte.",
                "À cette époque, j'ai notamment réalisé un éditeur de photo en Java. Sans connaissances des matrices de convolution ou des concepts de parallélisation et de distributions des calculs, j'arrivais à appliquer un filtre de \"netteté\" sur une image de 3000 par 4000 pixels en une dizaine de secondes. Aujourd'hui, ce projet me fait un peu rire, mais pour l'époque, j'avais réussi à construire un outil utilisable avec ce qui me semblait être des bouts de ficelles.",
                "Aussi, pour combler mon ennui durant les cours, j'avais réalisé un petit algorithme de ma conception pour résoudre une grille de Sudoku en Casio BASIC.",
            ],
        },
        En: {
            title: "Science Baccalaureat",
            text: [
                "I obtained my science baccalaureat with honours, at the High school of Image and Sound in Angoulême.",
                "During this time, I continued to teach myself computer science in my spare time.",
                "At that time, I notably created a photo editor in Java. Without knowledge of convolution matrices or the concepts of parallelization and distribution of calculations, I managed to apply a 'sharpness' filter on an image of 3000 by 4000 pixels in about ten seconds. Today, this project makes me laugh a little, but at the time, I had managed to build a usable tool with what seemed to me to be bits of string.",
                "Also, to fill my boredom during classes, I had created a small algorithm of my design to solve a Sudoku grid in Casio BASIC.",
            ],
        },
    },
    bia: {
        img: null,
        app: null,
        Fr: {
            title: "Brevet d'Initiation à l'Aéronautique",
            text: [
                "À la période du collège, j'étais passionné par les sciences, quelles qu'elles soient. Pour l'un de mes anniversaires, mes parents m'avaient offert un vol d'initiation à l'Aéroclub de mon département, ce que j'avais adoré. Lors de ce vol, nous avions rencontré un des instructeurs qui s'occupait du BIA au club. Et c'est ainsi que je me suis inscrit.",
                "Pendant un an, tous les samedis matin, j'ai donc suivi les cours dispensés par ces passionnés d'aéronautique. Même si j'avoue ne pas toujours avoir été totalement attentif, ces cours m'ont permis de découvrir un nouveau sujet scientifique. Notamment, ça m'a permis de comprendre comment l'association de sciences fondamentales comme la physique et les mathématiques permettent d'aboutir à des technologies aussi complexes qu'un avion.",
            ],
        },
        En: {
            title: "Aeornautical initiation certificate",
            text: [
                "When I was at secondary school, I had a passion for science, whatever it was. For one of my birthdays, my parents treated me to an introductory flight at the local flying club, which I loved. During the flight, we met one of the instructors who was in charge of the BIA at the club. And that's how I signed up.",
                "For a year, every Saturday morning, I attended classes taught by these aeronautics enthusiasts. Although I admit I wasn't always fully attentive, these classes allowed me to discover a new scientific subject. In particular, it helped me understand how the combination of fundamental sciences such as physics and mathematics leads to complex technologies like an airplane.",
            ],
        },
    },
    glasgow2025: {
        img: null,
        app: {
            command: "pdf-viewer",
            args: {
                url: "https://arxiv.org/pdf/2406.11161",
            },
        },
        note: null,
        Fr: {
            title: "Stage de M2",
            text: [
                "Pour mon stage de fin de master, j'ai refait le choix du GAIR-Lab avec Pr. Jose. Cette fois-ci, pour ce stage de recherche, le but était de recréer notre propre version du modèle proposé par Zebang Cheng : Emotion-LLaMA. Plus précisément, le but était donc de créer un chatbot spécialisé dans les émotions et l'analyse du visage. Néanmoins, j'avais un défi supplémentaire, je n'ai eu à ma disposition qu'un GPU RTX 3090 (ce qui est très peu pour faire tourner ce genre de modèle).",
                "Au moment où j'écris ces lignes, le stage n'est pas encore terminé, mais les premiers résultats sont assez prometteurs. J'ai réussi à construire une bibliothèque Python permettant de créer les pipelines de façon modulaire et multi-threadée tout en gardant le bénéfice d'un traitement des données séparé du traitement des modèles. Le pipeline que j'ai construit m'a permis de rendre le modèle LLaMA 3.2 1B (text-only au départ) capable de reconnaître des données multimodales (texte, image et audio) et d'en extraire des informations sur les émotions. D'ailleurs, la totalité du pipeline, en mode entraînement, tient sur le GPU de 24Go, avec un batch size de 8.",
                "Afin de mieux comprendre mon stage, je vous propose de découvrir le papier original de Zebang Cheng, sur lequel se base mon sujet de stage.",
            ],
        },
        En: {
            title: "Internship in Machine Learning Reasearch",
            text: [
                "For my master's thesis, I returned to the GAIR-Lab with Professor Jose. This time, the goal was to recreate our own version of the model proposed by Zebang Cheng: Emotion-LLaMA. More specifically, the aim was to create a chatbot specialized in emotions and facial analysis. However, I had an additional challenge: I only had access to an RTX 3090 GPU (which is very limited for running such models).",
                "As I write these lines, the internship is not yet complete, but the initial results are quite promising. I managed to build a Python library that allows for modular and multithreaded pipeline creation while maintaining the benefit of separating data processing from model processing. The pipeline I constructed enabled me to adapt the LLaMA 3.2 1B model (initially text-only) to recognize multimodal data (text, image, and audio) and extract information about emotions. Moreover, the entire pipeline, in training mode, fits within the 24GB GPU memory with a batch size of 8.",
                "To better understand my internship, I invite you to explore the original paper by Zebang Cheng, which serves as the foundation for my thesis topic.",
            ],
        },
    },
    glasgow2024: {
        img: null,
        app: {
            command: "pdf-viewer",
            args: {
                url: glasgow_m1,
            },
        },
        note: null,
        Fr: {
            title: "Stage de M1",
            text: [
                "Dans la première année de mon master, il y avait une obligation de réaliser un stage à l'étranger. Après discussion avec un camarade de ma promo, il est apparu qu'un de nos enseignants avait un contact très intéressant sur Glasgow : Pr. Jœmon JOSE. C'est ainsi que nous sommes partis, mon camarade et moi-même, à l'université ayant accueilli Lord Kelvin lui-même. Le laboratoire, où nous avons travaillé, est spécialisé dans le machine learning, notamment sur des sujets cherchant à comprendre les comportements non-dits humains.",
                "Le but de ce stage était de concevoir un démonstrateur pour le laboratoire affichant en temps réel les émotions d'un individu à partir de son visage. Pour cela, le projet se découpait en trois parties distincts : la partie Interface Homme-Machine (IHM), la partie Machine Learning et la partie du pipeline de traitement des données en temps réel. Personnellement, j'ai plutôt géré la partie pipeline tandis que mon camarade géré la partie IHM. Pour le machine learning, notre travail était globalement égalitaire.",
                "Le pipeline avait un cahier des charges simple : il devait fonctionner en temps réel et être suffisamment modulaire pour pouvoir être utilisé sur d'autres modèles du laboratoire. Pour cela, je suis parti sur une architecture 100% abstraite, sous forme de graphe, où un nœud du graphe se découpe en trois sous-ensembles (entrée, traitement et sortie). Tout le graphe est multi-threadé et marche selon le principe producteur-consommateur. Le pipeline utilise un nombre de threads fixe, mais répartit le nombre de threads à chacun de ses nœuds en fonction de l'avancement du traitement. Par exemple, au début du traitement tous les threads sont alloués aux premiers nœuds du graphe, puis au fur et à mesure que les nœuds avancent dans le traitement, les threads sont redistribués aux nœuds suivants. Jusqu'à ce que le traitement arrive à sa fin et que l'ensemble des threads soient utilisés par les derniers nœuds.",
                "En utilisant ce pipeline, et en optimisant bien les modèles et l'IHM, nous avons réussit à faire tourner le pipeline sur une entrée vidéo de 30 images par seconde, en conservant une latence assez faible (moins d'une seconde).",
                "Je vous propose de découvrir un petit papier, écrit dans le cadre d'un exercice, que nous avions réalisé à la fin de notre projet.",
            ],
        },
        En: {
            title: "Internship in Computer Science Reasearch",
            text: [
                "In the first year of my master's program, there was a requirement to complete an internship abroad. After discussing with a classmate, it turned out that one of our teachers had a very interesting contact in Glasgow: Professor Jœmon JOSE. That's how my classmate and I ended up at the university that once hosted Lord Kelvin himself. The laboratory where we worked specializes in machine learning, particularly on topics aimed at understanding unspoken human behaviors.",
                "The goal of this internship was to design a demonstrator for the laboratory that would display an individual's emotions in real-time based on their facial expressions. To achieve this, the project was divided into three distinct parts: the Human-Machine Interface (HMI), the Machine Learning component, and the real-time data processing pipeline. Personally, I primarily handled the pipeline part while my classmate managed the HMI. Our work on machine learning was fairly equal.",
                "The pipeline had a simple set of requirements: it needed to operate in real-time and be sufficiently modular to be used with other models in the laboratory. To achieve this, I opted for a 100% abstract architecture in the form of a graph, where each node in the graph is divided into three subsets (input, processing, and output). The entire graph is multithreaded and operates on a producer-consumer principle. The pipeline uses a fixed number of threads but distributes them among its nodes based on the progress of the processing. For example, at the beginning of the processing, all threads are allocated to the initial nodes of the graph, and as those nodes progress, threads are redistributed to subsequent nodes until the processing reaches its end and all threads are utilized by the final nodes.",
                "By using this pipeline and optimizing the models and HMI, we managed to run the pipeline on a video input of 30 frames per second while maintaining a relatively low latency (less than one second).",
                "I invite you to explore a short paper we wrote as part of an exercise at the end of our project.",
            ],
        },
    },
    reasearchLab2024: {
        img: null,
        app: {
            command: "pdf-viewer",
            args: {
                url: reasearchlab_m1,
            },
        },
        note: null,
        Fr: {
            title: "Projet en collaboration avec un doctorant",
            text: [
                "Dans le cadre de mon master orienté recherche, nous avions une unité d'enseignement nommée \"Reasearch Lab\". Le but de cette unité d'enseignement est de donner à des étudiants individuels un projet de recherche à réaliser en collaboration avec un doctorant de l'université. Pour ma part, j'ai eu la chance de travailler avec Maxime GAIDE, un doctorant en informatique de l'ENSMA-IASAE.",
                "Pour comprendre son travail de recherche, il faut d'abord savoir à quoi servent les G-maps et Jerboa. En vulgarisant, les G-maps sont simplement une manière de modéliser des objets dans un espace N-dimensionnel. Par exemple, on peut modéliser un cube dans un espace 3D avec une G-map. Pour ce qui est de Jerboa, c'est un outil de modélisation permettant de manipuler des objets construit avec des G-maps. Il fonctionne un peu sur le même principe qu'une recette de cuisine avec des opérations simples. Par exemple, pour construire une pyramide à base carrée, on commencera par créer la face carrée, que l'on va ensuite extruder pour créer un cube, puis on va \"réduire\" la face supérieure du cube en un simple sommet.",
                "La thèse de Maxime porte sur la manière d'ajouter des opérations au sein-même d'une recette de cuisine déjà créé (que l'on nomme \"spécification paramétrique\") afin de pouvoir reconstruire automatiquement des objets. Cette thèse prend tout son sens lorsqu'on l'associe à l'archéologie. En effet, les archéologues peuvent avoir diverses hypothèses sur la manière dont un bâtiment a été construit, mais ils n'ont pas forcément les moyens de tester toutes les hypothèses, car cela nécessite de créer une modélisation pour chaque hypothèse. C'est là que la thèse de Maxime prend tout son sens, car elle permet de créer une modélisation puis de tester des modifications sur cette modélisation sans avoir à la reconstruire entièrement.",
                "Mon travail pratique sur ce sujet était plutôt simple, je devais créer une interface graphique permettant de manipuler les G-maps sur Jerboa avec l'outil créé par Maxime. Parallèlement, il y avait également un but théorique assez important. Puisque le but de cette unité d'enseignement était de nous immerger dans un projet de recherche, nous devions aussi rédiger un poster et apporter une analyse théorique du sujet. Pour ma part, cette analyse théorique avait pour but d'apporter une vision temporelle à la reconstruction des objets. En effet, la thèse de Maxime porte sur la reconstruction d'objets, mais elle ne prend pas en compte le temps, qui est une variable importante dans l'archéologie.",
                "Je vous propose de découvrir le poster que j'ai réalisé dans le cadre de ce projet.",
            ],
        },
        En: {
            title: "Project in collaboration with a PhD student",
            text: [
                "As part of my research-oriented master's program, we had a course called 'Research Lab.' The goal of this course is to assign individual students a research project to be carried out in collaboration with a PhD student from the university. I was fortunate to work with Maxime GAIDE, a PhD student in computer science at ENSMA-IASAE.",
                "To understand his research work, it's essential to first grasp the purpose of G-maps and Jerboa. In simple terms, G-maps are just a way to model objects in an N-dimensional space. For example, you can model a cube in 3D space using a G-map. As for Jerboa, it's a modeling tool that allows you to manipulate objects built with G-maps. It operates somewhat like a cooking recipe with simple operations. For instance, to create a pyramid with a square base, you would start by creating the square face, then extrude it to form a cube, and finally 'reduce' the upper face of the cube to a single vertex.",
                "Maxime's thesis focuses on how to add operations within an already created 'cooking recipe' (known as 'parametric specification') to automatically reconstruct objects. This thesis becomes particularly relevant when associated with archaeology. Archaeologists may have various hypotheses about how a building was constructed but may not have the means to test all hypotheses since it requires creating a model for each one. This is where Maxime's thesis shines, as it allows for creating a model and testing modifications without having to rebuild it entirely.",
                "My practical work on this subject was relatively straightforward: I had to create a graphical interface for manipulating G-maps in Jerboa using the tool developed by Maxime. Additionally, there was also an important theoretical goal. Since the purpose of this course was to immerse us in a research project, we also had to write a poster and provide a theoretical analysis of the topic. My theoretical analysis aimed to introduce a temporal dimension to object reconstruction. While Maxime's thesis focuses on object reconstruction, it does not consider time, which is an important variable in archaeology.",
                "I invite you to explore the poster I created for this project.",
            ],
        },
    },
    shibpur2023: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Stage de L3",
            text: [
                "En 2023, un enseignant de mon université nous a envoyé un mail pour nous proposer un stage de recherche à l'IIEST Shibpur, en Inde. Après avoir d'abord refusé l'idée, et après en avoir discuté avec une amie intéressée, nous avons finalement décidé de répondre à la proposition. Nous avons donc réalisé un stage de 3 mois dans un laboratoire de recherche en Machine Learning. Cette expérience a sans doute été l'une des plus enrichissantes pour moi, tant sur le plan personnel que professionnel.",
                "Durant ce stage, notre but était de développer un proof-of-concept. Même si ça n'a pas d'intérêt scientifique, le but était de développer un modèle de deep learning capable de détecter les paramètres d'une ligne droite dans une image. Pour cela, nous avons tenté différentes approches, des approches à base de CNN et des approches à base de Seq2Seq. Malgré de gros efforts pour y parvenir, malheureusement, ce projet n'a pas abouti au résultat attendu. En effet, en Inde, il y avait un gros manque de moyens pour notre projet. De plus, à l'époque, nous découvrions beaucoup des concepts liés à ce projet : la géométrie discrète ou le machine learning par exemple.",
            ],
        },
        En: {
            title: "Internship in Machine Learning Reasearch",
            text: [
                "In 2023, one of my university teachers sent us an email proposing a research internship at IIEST Shibpur in India. Initially hesitant, after discussing it with a friend who was also interested, we ultimately decided to accept the offer. We completed a 3-month internship in a research laboratory focused on Machine Learning. This experience was undoubtedly one of the most enriching for me, both personally and professionally.",
                "During this internship, our goal was to develop a proof-of-concept. Although it lacked scientific significance, the aim was to create a deep learning model capable of detecting the parameters of a straight line in an image. We explored various approaches, including CNN-based methods and Seq2Seq techniques. Despite significant efforts, unfortunately, this project did not yield the expected results. In India, we faced substantial resource limitations for our project. Additionally, at that time, we were still discovering many concepts related to this project, such as discrete geometry and machine learning.",
            ],
        },
    },
    xlim2023: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Projet en laboratoire",
            text: [
                "En 2023, notre enseignant de CMI, Thierry Urruty, a proposé, à notre promo, de réaliser un petit projet, d'une durée totale d'une semaine, en collaboration avec la société Einden, éditrice du logiciel Ephoto Dam. Le but de ce projet était de retrouver des images doublons ou similaires dans une base de données d'images.",
                "Pour cela, nous avions chacun choisi des approches différentes. Pour ma part, j'ai choisi d'utiliser les Deep Features, une approche basée sur les réseaux de neurones convolutifs (CNN). J'ai donc calculé les Deep Features des différentes images de la base de données, puis j'ai utilisé la distance euclidienne des tenseurs calculés pour tenter de rapprocher les images. En utilisant cette approche, j'ai réussi à retrouver quelques images similaires, mais pas toutes. En effet, j'utilisais le modèle YOLO pour calculer les Deep Features. Mais ce modèle n'est pas forcément adapté pour ce genre de tache, car il est plutôt conçu pour détecter des objets dans une image. De plus, l'utilisation de la distance euclidienne n'est pas forcément la meilleure solution pour rapprocher des tenseurs, l'algorithme de K-means aurait sans doute été plus adapté.",
                "Néanmoins, la société Einden a été satisfaite des différentes approches que nous avions proposées. Même si personne n'avait réussi à trouver une solution 100% satisfaisante, nous avions tous réussi à apporter une solution à un problème complexe. En nous laissant plus de temps, nous aurions sans doute réussi à tous trouver une solution parfaite.",
            ],
        },
        En: {
            title: "Project with a laboratory",
            text: [
                "In 2023, our CMI teacher, Thierry Urruty, proposed a small project to our class in collaboration with Einden, the publisher of the Ephoto Dam software. The goal of this project was to find duplicate or similar images in a database of images.",
                "To achieve this, we each chose different approaches. For my part, I opted to use Deep Features, an approach based on Convolutional Neural Networks (CNN). I calculated the Deep Features of the various images in the database and then used the Euclidean distance of the calculated tensors to try to bring the images closer together. Using this approach, I managed to find some similar images, but not all of them. Indeed, I was using the YOLO model to calculate the Deep Features. However, this model is not necessarily suitable for this type of task, as it is primarily designed to detect objects in an image. Moreover, using Euclidean distance is not necessarily the best solution for bringing tensors closer together; the K-means algorithm would probably have been more appropriate.",
                "Nevertheless, the Einden company was satisfied with the different approaches we had proposed. Even though no one had managed to find a 100% satisfactory solution, we had all succeeded in providing a solution to a complex problem. Given more time, we would undoubtedly have all found a perfect solution.",
            ],
        },
    },
    xlim2022: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Stage en laboratoire",
            text: [
                "Comme chaque début d'été en CMI, j'ai réalisé un stage à XLIM, le laboratoire de l'université de Poitiers. Cette année-là, il y avait deux projets proposés, et nous avons été répartis en deux groupes. Pour ma part, j'ai travaillé, avec trois autres personnes, sur un petit robot basé sur un Raspberry Pi, qui devait être capable de reconnaître son environnement et de se déplacer de manière autonome.",
                "Pour cela, nous avons commencé par créer un parcours au robot dans lequel nous avions placé divers objets. Ensuite, nous avons fait tourner sur le Raspberry Pi un modèle de deep learning très léger, que nous avons entraîné à reconnaître les objets du parcours. Enfin, une fois qu'un objet était reconnu, le robot était programmé pour passer dans un autre mode, où il tentait de s'orienter en fonction de la place qu'occupait l'objet dans son champ de vision. Cette dernière étape ne fonctionnait pas très bien, notre approche était trop complexe à mettre en place pour notre niveau de L2.",
                "Néanmoins, ce stage m'a permis de découvrir le travail en équipe, car nous étions quatre à travailler sur ce projet et nous avions chacun un rôle bien défini. De plus, nous nous étions un peu attacher au comportement que nous avions donné au robot, nous l'avions même surnommé \"Terminator\".",
            ],
        },
        En: {
            title: "Internship with a laboratory",
            text: [
                "As with every early summer in the CMI program, I completed an internship at XLIM, the laboratory of the University of Poitiers. That year, there were two projects proposed, and we were divided into two groups. I worked with three other people on a small robot based on a Raspberry Pi that was supposed to recognize its environment and move autonomously.",
                "To achieve this, we started by creating a course for the robot, placing various objects along the way. Then, we ran a very lightweight deep learning model on the Raspberry Pi, which we trained to recognize the objects in the course. Finally, once an object was recognized, the robot was programmed to switch to another mode where it attempted to orient itself based on the position of the object in its field of vision. This last step didn't work very well; our approach was too complex for our level at that time.",
                "Nevertheless, this internship allowed me to discover teamwork, as we were four working on this project, each with a well-defined role. Additionally, we had become somewhat attached to the behavior we had given the robot, even nicknaming it 'Terminator'.",
            ],
        },
    },
    nexeya2019: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Stage de découverte en ingénierie",
            text: [
                "À l'époque du lycée, j'étais toujours autant passionné par les sciences, et notamment par l'informatique et la chimie. Pour mon orientation, j'hésitais entre deux voies : l'informatique et la pharmacie. Pour m'aider à choisir, j'ai donc réalisé un stage de découverte en ingénierie chez Nexeya France, une entreprise spécialisée dans l'ingénierie et la conception de systèmes pour l'aérospatial, la défense, l'énergie et les transports. Au cours de cette semaine, je suis passé par presque tous les services de l'entreprise, et j'ai pu découvrir les différents métiers liés à l'ingénierie.",
                "Ce stage a été pour moi une véritable révélation. Il m'a aidé à comprendre que l'informatique était ma véritable passion, et que je voulais en faire mon métier. J'ai également découvert que finalement, l'informatique contrairement à la pharmacie, me permettait de travailler dans des domaines variés et passionnants, touchant à tout un tas de domaines et de sciences différentes.",
            ],
        },
        En: {
            title: "Internship in engineering",
            text: [
                "In high school, I was always passionate about science, particularly computer science and chemistry. To help me choose my path, I completed an engineering discovery internship at Nexeya France, a company specializing in the engineering and design of systems for aerospace, defense, energy, and transportation. During this week, I went through almost all the company's departments and was able to discover the different professions related to engineering.",
                "This internship was a real revelation for me. It helped me understand that computer science was my true passion and that I wanted to make it my career. I also discovered that, unlike pharmacy, computer science allowed me to work in various exciting fields, touching on a wide range of different domains and sciences.",
            ],
        },
    },
    imagine2016: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Stage de découverte au collège",
            text: [
                "Au collège pour mon stage de découverte, j'ai réalisé un stage dans un petit magasin d'électronique, d'informatique et de son : Imagine et Son. J'y ai découvert plein d'aspects variés et notamment le fonctionnement d'une petite entreprise et la relation client. Cette semaine avait été très enrichissante pour le jeune collégien que j'étais.",
            ],
        },
        En: {
            title: "Internship in electronics",
            text: [
                "In middle school, for my discovery internship, I completed a week at a small electronics, computer, and audio store: Imagine et Son. I discovered many varied aspects, including how a small business operates and customer relations. This week was very enriching for the young middle school student I was.",
            ],
        },
    },
    skDeepLearning: {
        img: null,
        app: null,
        note: "glasgow2025",
        Fr: {
            title: "Compétences en Deep Learning",
            text: [
                "Tout au long de mon parcours universitaire, j'ai souvent été amené à travailler sur des projets utilisant le Deep Learning. En effet, le laboratoire XLIM, lié à l'université de Poitiers, est un laboratoire de recherche en informatique graphique. Il y a donc beaucoup de projets utilisant le Deep Learning, notamment dans le domaine de la vision par ordinateur. J'ai toujours trouvé ce domaine passionnant, et c'est pour moi un domaine qui contrairement à ce que l'on pourrait penser, n'a pas pour but de remplacer l'algorithmie classique, mais de résoudre les problèmes que l'algorithmie classique ne peut pas résoudre.",
                "Je n'aime pas l'idée de dire que le Deep Learning est la solution à tous les problèmes, loin de là. Néanmoins, je pense que c'est un outil puissant qui peut être utilisé pour résoudre des problèmes complexes, notamment dans des domaines où les avancées algorithmiques sont limitées pour le moment.",
            ],
        },
        En: {
            title: "Skills in Deep Learning",
            text: [
                "Throughout my academic journey, I have frequently worked on projects involving Deep Learning. The XLIM laboratory, affiliated with the University of Poitiers, is a research lab in computer graphics, which means there are many projects utilizing Deep Learning, particularly in the field of computer vision. I have always found this field fascinating, and I believe it is an area that, contrary to popular belief, does not aim to replace classical algorithms but rather to solve problems that classical algorithms cannot address.",
                "I dislike the notion that Deep Learning is the solution to all problems; far from it. However, I believe it is a powerful tool that can be employed to tackle complex issues, especially in areas where algorithmic advancements are currently limited.",
            ],
        },
    },
    skParallelization: {
        img: null,
        app: null,
        note: "glasgow2024",
        Fr: {
            title: "Compétences en Parallélisation",
            text: [
                "Sans doute, l'un des domaines que j'affectionne le plus dans l'informatique, la parallélisation est sans doute la solution à de nombreux problèmes. J'ai souvent eu l'occasion de travailler sur des projets qui requièrent une parallélisation, notamment dans le cadre de mes stages et projets universitaires.",
                "La parallélisation est un domaine qui me rappelle beaucoup mon instrument de musique, la batterie. En effet, à la batterie, il faut être capable de jouer plusieurs rythmes sur chaque membre de son corps, tout en gardant une cohérence dans l'ensemble. De la même manière, en informatique, il faut être capable de paralléliser les tâches pour qu'elles soient exécutées de manière cohérente et efficace. Lors de mon stage à l'université de Glasgow, en 2024, j'ai notamment développé un pipeline capable de paralléliser les tâches de traitement tout en gardant une cohérence dans l'ensemble. Ce pipeline est capable de s'adapter aux besoins du traitement, en allouant les ressources nécessaires à chaque tâche. Je vous laisse découvrir dans la note suivante.",
            ],
        },
        En: {
            title: "Skills in Parallelization",
            text: [
                "Undoubtedly one of my favorite areas in computer science, parallelization is often the solution to many problems. I have frequently had the opportunity to work on projects that require parallelization, particularly in the context of my internships and university projects.",
                "Parallelization reminds me a lot of my musical instrument, the drums. On the drums, you need to be able to play multiple rhythms with each part of your body while maintaining coherence in the overall performance. Similarly, in computer science, you need to be able to parallelize tasks so that they are executed coherently and efficiently. During my internship at the University of Glasgow in 2024, I developed a pipeline capable of parallelizing processing tasks while maintaining overall coherence. This pipeline can adapt to the processing needs by allocating the necessary resources to  each task. I invite you to explore the next note for more details.",
            ],
        },
    },
    skLowLevel: {
        img: null,
        app: {
            command: "github",
        },
        note: null,
        Fr: {
            title: "Compétences en Bas-niveau",
            text: [
                "À la fac, l'un des premiers cours que j'ai suivi à m'avoir passionné pleinement était un cours d'architecture des ordinateurs. Dans ce cours, nous avons étudié, en détail, le fonctionnement d'un processeur, d'une mémoire et d'un bus. Nous avons également recréé en VHDL un processeur simple, capable d'exécuter des instructions basiques. Ce cours m'a permis de comprendre comment fonctionne un ordinateur, et comment les différents composants interagissent entre eux.",
                "Ce cours a rapidement été suivi de deux autres cours liés au bas-niveau : un cours de systèmes d'exploitation et un cours de réseaux. Ces deux cours m'ont permis de comprendre comment les systèmes d'exploitation interagit avec le matériel, et également comment plusieurs ordinateurs peuvent interagir entre eux.",
                "Depuis, j'ai souvent eu l'occasion de travailler sur des projets qui requièrent des compétences en bas-niveau, notamment dans le cadre de l'unité d'enseignement \"Gestion de projet\" en L3, où j'ai développé un protocole de communication entre plusieurs ordinateurs. Le but de ce cours était de développer un joueur virtuel de Gomoku, un jeu de société japonais. Pour cela, la promo a été divisée en une vingtaine de groupes, chacun développant son joueur virtuel. Le but final était de faire s'affronter les joueurs virtuels entre eux. Pour cela, j'ai été chargé de développer un protocole de communication entre les joueurs virtuels, afin qu'ils puissent s'affronter. Sauf que chaque équipe était libre de choisir le langage de programmation qu'elle souhaitait utiliser. Par chance, seul trois langages ont été utilisés : Python, Java et C. J'ai donc développé un protocole de communication en C, qui permettait aux joueurs virtuels de communiquer entre eux, quel que soit le langage de programmation utilisé. Ce protocole était basé sur des sockets, et permettait d'envoyer des positions de jeu entre les joueurs virtuels.",
            ],
        },
        En: {
            title: "Skills in Low-level Programming",
            text: [
                "At university, one of the first courses that fully captivated me was a computer architecture course. In this course, we studied in detail how a processor, memory, and bus work. We also recreated a simple processor in VHDL capable of executing basic instructions. This course allowed me to understand how a computer works and how its various components interact with each other.",
                "This course was quickly followed by two others related to low-level programming: an operating systems course and a networking course. These two courses helped me understand how operating systems interact with hardware and how multiple computers can communicate with each other.",
                "Since then, I have often had the opportunity to work on projects requiring low-level programming skills, particularly in the 'Project Management' course in my third year, where I developed a communication protocol between multiple computers. The goal of this course was to develop a virtual Gomoku player, a Japanese board game. The class was divided into about twenty groups, each developing its own virtual player. The final goal was to have these virtual players compete against each other. I was tasked with developing a communication protocol between the virtual players so they could compete. Fortunately, only three programming languages were used: Python, Java, and C. I developed a communication protocol in C that allowed the virtual players to communicate with each other regardless of the programming language used. This protocol was based on sockets and enabled the exchange of game positions between the virtual players.",
            ],
        },
    },
    sk3DAlgorithms: {
        img: tree_d_raycasting,
        app: {
            command: "3d-algorithm",
            args: null,
        },
        note: null,
        Fr: {
            title: "Compétences en Algorithmie 3D",
            text: [
                "J'ai découvert assez tardivement l'algorithmie 3D, mais c'est un domaine qui m'a rapidement passionné. Le premier de mes projets dans ce domaine était la conception d'un moteur de rendu 3D en Java, sans utiliser de bibliothèque externe. J'ai développé un moteur de rendu 3D capable de représenter des objets 3D simples, comme des cubes ou des sphères. J'y avais implémenté divers effets de lumière. Et j'avais réussi à obtenir un rendu tout à fait acceptable pour un programme qui n'utilisait pas OpenGL ou une autre API de rendu.",
                "Un autre projet, plus récent, a été réalisé avec ma camarade, Léna Proust, dans le cadre de l'unité d'enseignement \"Algorithmie 3D 2\". Dans ce projet, nous avons réalisé une scène 3D en WebGL pur, où divers aspects de l'algorithmie 3D étaient mis en avant. Par exemple, nous avons implémenté un système, simulant un lancé de rayons au sein du BoundingBox. WebGL ne permet normalement pas de gérer les lancés de rayon, c'est pourquoi l'optimisation du shader était primordiale. Je vous propose d'ailleurs de découvrir ce projet. Pour qu'il fonctionne au mieux pour vous, je vous recommande d'activer votre carte graphique sur votre navigateur dans les paramètres de votre système.",
            ],
        },
        En: {
            title: "Skills in 3D Algorithms",
            text: [
                "I discovered 3D algorithms relatively late, but it is a field that quickly captivated me. The first of my projects in this area was the design of a 3D rendering engine in Java, without using any external libraries. I developed a 3D rendering engine capable of representing simple 3D objects, such as cubes or spheres. I implemented various lighting effects in it. And I managed to achieve a quite acceptable rendering for a program that did not use OpenGL or another rendering API.",
                'Another, more recent project was carried out with my classmate, Léna Proust, as part of the "3D Algorithms 2" course. In this project, we created a 3D scene in pure WebGL, where various aspects of 3D algorithms were highlighted. For example, we implemented a system simulating ray casting within the BoundingBox. WebGL normally does not allow for ray casting, which is why shader optimization was paramount. I invite you to discover this project. To ensure it works best for you, I recommend enabling your graphics card in your browser\'s system settings.',
            ],
        },
    },
    skCCpp: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en C/C++",
            text: [
                "J'ai souvent programmé en C ou en C++. C'est pour moi, les meilleurs langages à utiliser lorsque l'on souhaite avoir des performances pures. Ce sont des langages que je qualifierai de \"chirurgicale\" il demande une rigueure absolue et une finesse de programmation parfaite. Je prends beaucoup de plaisir à les utiliser dans mes projets.",
            ],
        },
        En: {
            title: "Skills in C/C++",
            text: [
                "I have often programmed in C or C++. For me, these are the best languages to use when you want pure performance. I would describe them as 'surgical' languages; they require absolute rigor and perfect programming finesse. I take great pleasure in using them in my projects.",
            ],
        },
    },
    skPython: {
        img: null,
        app: null,
        note: "xlim2022",
        Fr: {
            title: "Compétences en Python",
            text: [
                "Lors de l'ensemble de mes stages de recherche, j'ai quasiment systématiquement utilisé Python. Ce n'est pas forcément un langage que j'apprécie, il est, pour moi, beaucoup trop permissif et ne permet pas d'assurer la rigueur dans le code. Néanmoins, c'est le langage parfait pour faire du prototypage et des essais rapide. En Python, tout existe déjà, il suffit juste d'assembler les briques ensembles.",
            ],
        },
        En: {
            title: "Skills in Python",
            text: [
                "In all of my research internships, I have almost always used Python. It is not necessarily a language I enjoy; for me, it is too permissive and does not ensure code rigor. However, it is the perfect language for prototyping and quick testing. In Python, everything already exists; you just need to assemble the building blocks together.",
            ],
        },
    },
    skJava: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en Java",
            text: "L'un de mes chouchous avec le C++, c'est le langage avec lequel j'ai commencé à programmer des choses complexes, vers mes douze ans. J'ai passé des journées entières à modifier Minecraft avec ce langage. À la fac, j'ai souvent eu l'occasion de retravailler en Java. Il allie selon moi beaucoup d'avantages : cross-plateforme, bonne gestion mémoire par garbage collector, une syntaxe claire et précise. Le seul reproche que je puisse faire à ce langage, c'est le fait qu'on perde un peu de performance sur la JVM.",
        },
        En: {
            title: "Skills in Java",
            text: "Java is one of my favorites, along with C++. It was the language I started using for complex programming tasks around the age of twelve. I spent countless hours modifying Minecraft with this language. At university, I often had the opportunity to work with Java again. It combines many advantages: cross-platform compatibility, good memory management through garbage collection, and a clear and precise syntax. The only criticism I have of this language is that it can lose some performance on the JVM.",
        },
    },
    skJavaScript: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en JavaScript",
            text: "Le JavaScript est pour moi du même acabit que le python, c'est un langage avec plein de défauts, mais pour un usage précis, qui est le développement web, il fonctionne plutôt très bien. Même si, aujourd'hui, le TypeScript corrige de nombreux problèmes du JavaScript, il reste un incontournable du web. C'est d'ailleurs avec ce dernier que ce site à été développé.",
        },
        En: {
            title: "Skills in JavaScript",
            text: "JavaScript is a language I appreciate for its versatility and ubiquity in web development. It has its flaws, but for specific use cases, particularly in web development, it works quite well. Today, TypeScript addresses many of JavaScript's issues, yet JavaScript remains a staple of the web. In fact, this site was developed using it.",
        },
    },
    skOcaml: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en OCaml",
            text: "À Poitiers, l'algorithmie n'est pas enseignée avec Python, mais avec Ocaml. C'est un langage détestable aux premiers abords : il a une syntaxe vieillissante qui ne permet aucune folie et son fort typage est parfois déconcertant. Mais lorsque l'on commence à le découvrir complétement, ça devient rapidement le meilleur langage interprété (loin devant le Python ou le JavaScript, par exemple...). En plus, le fait qu'il ait une vérification fonctionnelle de son interpréteur, il assure de réaliser des programmes sans miscompilation.",
        },
        En: {
            title: "Skills in OCaml",
            text: "At the University of Poitiers, algorithms are not taught with Python but with OCaml. It is a language that can be off-putting at first glance: it has an outdated syntax that allows for no frills, and its strong typing can be disconcerting. However, once you start to fully explore it, it quickly becomes the best interpreted language (far ahead of Python or JavaScript, for example...). Additionally, its functional verification ensures that programs are executed without miscompilation.",
        },
    },
    skCSharp: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en C#",
            text: "Ma relation avec le C# se limite à une utilisation avec Unity. J'ai souvent réalisé des projets avec Unity et je dois avouer que l'utilisation du C# pour ce type de développement apparaît, pour moi, complétement naturelle. C'est le langage intermédiaire parfait au C++ et au Java, il corrige les défauts de l'un avec les avantages de l'autre. De plus, lorsque l'on maîtrise ces deux langages, la syntaxe du C# n'a rien de difficile, tout au contraire.",
        },
        En: {
            title: "Skills in C#",
            text: "My relationship with C# is limited to its use with Unity. I have often completed projects with Unity, and I must admit that using C# for this type of development seems completely natural to me. It is the perfect intermediate language between C++ and Java, correcting the flaws of one with the advantages of the other. Furthermore, once you master these two languages, the syntax of C# is not difficult at all; quite the opposite.",
        },
    },
    skACSL: {
        img: null,
        app: null,
        note: "skCoq",
        Fr: {
            title: "Compétences en ACSL",
            text: "Lors de ma formation, j'ai eu l'occasion de découvrir, dans le cadre de plusieurs cours sur le langage de spécification formelle, l'ACSL. C'est un langage, qui permet de spécifier des propriétés d'un code source C. C'est dans ce cadre que je l'ai toujours utilisé pour vérifier le comportement d'un programme, notamment dans le cadre de la vérification formelle. J'ai trouvé ce langage très intéressant, et je trouve qu'il est très utile de comprendre les aspects formels de la programmation.",
        },
        En: {
            title: "Skills in ACSL",
            text: "I have had the opportunity to discover ACSL as part of several courses on formal specification languages during my training. It is a language that allows specifying properties of C source code. I have always used it in this context to verify the behavior of a program, particularly in the context of formal verification. I found this language very interesting, and I believe it is very useful to understand the formal aspects of programming.",
        },
    },
    skCoq: {
        img: null,
        app: null,
        note: "skACSL",
        Fr: {
            title: "Compétences en Coq",
            text: "Lors des mêmes cours que j'ai suivi pour l'ACSL, j'ai également eu l'occasion de découvrir le Coq. C'est un langage de preuve formelle, qui permet de prouver des propriétés d'un programme. Toujours dans cet esprit de vérification formelle, j'ai trouvé ce langage très pertinent. D'autant plus que sa syntaxe est très proche de l'Ocaml, ce qui le rend assez simple d'utilisation (une fois que l'on a compris le principe de l'Ocaml).",
        },
        En: {
            title: "Skills in Coq",
            text: "During the same courses I took for ACSL, I also had the opportunity to discover Coq. It is a formal proof language that allows proving properties of a program. Always in this spirit of formal verification, I found this language very relevant. Moreover, its syntax is very close to Ocaml, which makes it quite easy to use (once you understand the principles of Ocaml).",
        },
    },
    skGit: {
        img: null,
        app: {
            command: "github",
            args: null,
        },
        note: null,
        Fr: {
            title: "Compétences en Git",
            text: "Bien avant de commencer mes études supérieures, j'ai découvert Git. J'ai commencé à l'utiliser pour gérer mes projets personnels, puis j'ai rapidement commencé à l'utiliser pour collaborer avec d'autres personnes sur des projets communs. Après ne l'avoir utilisé qu'en local, j'ai finis par l'utiliser sur des plateformes en ligne. Vous pouvez d'ailleurs voir que mon profil GitHub existe depuis 2018 (même si la plupart de mes repos de l'époque ont été supprimés). À la fac, j'ai continué à l'utiliser pour gérer absolument tous mes projets, que ce soit en groupe ou en solo. C'est un outil que je trouve indispensable, associé à GitHub, il permet de gérer facilement les versions d'un projet, de collaborer avec d'autres personnes et d'assurer une sauvegarde permanente de son travail. Je ne compte plus le nombre de fois où Git m'a sauvé la vie en me permettant de retrouver une version antérieure d'un projet ou après une mise à jour de mon PC qui est mal passé.",
        },
        En: {
            title: "Skills in Git",
            text: "Long before starting my higher education, I discovered Git. I began using it to manage my personal projects and quickly started using it to collaborate with others on shared projects. After initially using it locally, I eventually used it on online platforms. You can see that my GitHub profile has existed since 2018 (even though most of my repositories from that time have been deleted). At university, I continued to use it to manage all my projects, whether in groups or solo. It is an indispensable tool; when combined with GitHub, it allows for easy version management of a project, collaboration with others, and permanent backup of one's work. I have lost count of how many times Git has saved me by allowing me to retrieve a previous version of a project or after a problematic update to my PC.",
        },
    },
    skLatex: {
        img: null,
        app: null,
        note: "glasgow2024",
        Fr: {
            title: "Compétences en LaTeX",
            text: "En M1, j'ai découvert le LaTeX, le langage de balisage pour la rédaction de documents, avant ça, j'avais l'habitude d'utiliser les outils fournis par la suite Microsoft Office. J'ai rapidement été séduit par la puissance de ce langage, qui permet de créer des documents de qualité professionnelle, tout en étant très flexible. Personnellement, je trouve que je suis plus productif avec LaTeX qu'avec l'ensemble des outils de bureautique que j'ai pu utiliser auparavant. Mais je suis totalement capable d'utiliser des outils plus conventionnels si on me le demande.",
        },
        En: {
            title: "Skills in LaTeX",
            text: "In my first year of master's, I discovered LaTeX, the markup language for document preparation. Before that, I was used to using tools provided by the Microsoft Office suite. I quickly became enamored with the power of this language, which allows for the creation of professional-quality documents while being very flexible. Personally, I find that I am more productive with LaTeX than with all the office tools I have used before. However, I am fully capable of using more conventional tools if requested.",
        },
    },
    skCUDA: {
        img: null,
        app: null,
        note: "glasgow2025",
        Fr: {
            title: "Compétences en CUDA",
            text: "En master, nous avons eu un cours sur les calculs parallèles et répartis, CUDA était au programme de ce cours. J'ai rapidement été séduit par la puissance de ce langage, qui permet de paralléliser massivement les calculs sur les GPU. Depuis ce cours, j'ai souvent utilisé CUDA ou d'autres langages de parallélisation pour développer des applications nécessitant des calculs intensifs. Par exemple, lors de mes deux stages à l'université de Glasgow, mes connaissances en CUDA m'ont permis de résoudre de nombreux problèmes de parallélisation et d'optimiser au mieux la mémoire GPU utilisée.",
        },
        En: {
            title: "Skills in CUDA",
            text: "In my master's program, we had a course on parallel and distributed computing, and CUDA was part of the curriculum. I quickly became enamored with the power of this language, which allows for massive parallelization of computations on GPUs. Since that course, I have often used CUDA or other parallelization languages to develop applications requiring intensive calculations. For example, during my two internships at the University of Glasgow, my knowledge of CUDA allowed me to solve many parallelization problems and optimize GPU memory usage effectively.",
        },
    },
    skOpenGL: {
        img: null,
        app: {
            command: "3d-algorithm",
            args: null,
        },
        note: null,
        Fr: {
            title: "Compétences en OpenGL",
            text: "Lors de mes études, j'ai eu l'occasion de découvrir OpenGL, une API de rendu 3D. J'ai rapidement été séduit par la puissance de cette API, qui permet de créer des applications 3D performantes et flexibles. J'adore la programmation des shaders, c'est pour moi l'un des aspects les plus intéressants de la programmation 3D. Depuis, ma découverte d'OpenGL, j'ai également utilisé des API sœurs comme WebGL ou Vulkan. Je vous propose d'ailleurs de découvrir un projet réalisé avec ma camarade Léna Proust, dans le cadre d'un cours d'algorithmie 3D. Ce projet propose, sur une scène 3D, divers aspects de l'algorithmie 3D, notamment un système de lancer de rayons volumique dans une bounding box permettant d'afficher des images d'IRM.",
        },
        En: {
            title: "Skills in OpenGL",
            text: "During my studies, I had the opportunity to discover OpenGL, a 3D rendering API. I quickly became enamored with the power of this API, which allows for the creation of high-performance and flexible 3D applications. I love shader programming; it is one of the most interesting aspects of 3D programming for me. Since discovering OpenGL, I have also used sister APIs like WebGL and Vulkan. I invite you to explore a project created with my classmate Léna Proust as part of a 3D algorithms course. This project showcases various aspects of 3D algorithms on a 3D scene, including a volumetric ray casting system within a bounding box that displays MRI images.",
        },
    },
    skNodeJS: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en Node.js",
            text: "De nombreux projets que j'ai réalisés, notamment dans le cadre de mes études, reposaient sur Node.js. Le site que vous êtes en train de consulter est d'ailleurs développé avec Node.js (et React aussi). C'est un bon outil pour créer des applications web et des API. Même si je dois avouer que le web n'est pas ma passion première, je n'ai pas de problème à utiliser Node.js pour développer des applications web ou des API.",
        },
        En: {
            title: "Skills in Node.js",
            text: "Many of the projects I have worked on, particularly during my studies, were based on Node.js. The site you are currently visiting is also developed with Node.js (and React as well). It is a good tool for creating web applications and APIs. Even though I must admit that the web is not my primary passion, I have no problem using Node.js to develop web applications or APIs.",
        },
    },
    skUnity: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en Unity",
            text: "Depuis que j'ai commencé le développement quand j'étais au collège, j'ai toujours été passionné par la création de jeux vidéo. Ma relation avec Unity est ce que je qualifierai d'intermittente, des fois, je l'utilise intensivement pour développer un petit jeu (souvent pas terrible), puis du jour au lendemain, je ne l'utilise plus pendant des mois. Mais j'ai toujours gardé un œil sur les nouveautés d'Unity, et je suis toujours prêt à l'utiliser pour développer un jeu ou une application interactive.",
        },
        En: {
            title: "Skills in Unity",
            text: "Since I started development in middle school, I have always been passionate about creating video games. My relationship with Unity is what I would call intermittent; sometimes I use it intensively to develop a small game (often not great), then overnight I stop using it for months. But I have always kept an eye on Unity's new features, and I am always ready to use it to develop a game or an interactive application.",
        },
    },
    skBlender: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en Blender",
            text: "Lorsque j'étais au collège, je faisais partie d'un club de création de vidéo. À cette époque, j'étais en charge de la création du générique et j'avais choisi d'utiliser Blender pour cela. Depuis, j'ai continué à utiliser Blender pour créer des modèles 3D ou des animations. Mon niveau artistique n'est pas exceptionnel, mais je suis capable de créer des modèles 3D simples, de modifier un modèle existant ou de créer une animation simple. D'ailleurs, j'ai connu Blender avant qu'il ne change d'interface, et je dois avouer qu'il s'est beaucoup amélioré et simplifié depuis.",
        },
        En: {
            title: "Skills in Blender",
            text: "When I was in middle school, I was part of a video creation club. At that time, I was responsible for creating the credits, and I chose to use Blender for that. Since then, I have continued to use Blender to create 3D models or animations. My artistic level is not exceptional, but I am capable of creating simple 3D models, modifying an existing model, or creating a simple animation. By the way, I knew Blender before it changed its interface, and I must admit that it has improved and simplified a lot since then.",
        },
    },
    skVSCode: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en Visual Studio Code",
            text: "Certainement mon outil de développement préféré, Visual Studio Code est selon moi l'éditeur parfait pour développer n'importe quel type de projet. Il est léger, rapide et extensible à souhait. J'ai presque toujours utilisé Visual Studio Code pour développer mes projets, que ce soit en C, en Python, en JavaScript ou dans d'autres langages. Seule exception, lorsque je développe un projet Java, je préfère utiliser Eclipse, c'est lié à une vielle habitude que j'ai prise au collège. Je connais plutôt bien Visual Studio Code, et je l'ai utilisé dans de multiples situations, plus variées les unes que les autres.",
        },
        En: {
            title: "Skills in Visual Studio Code",
            text: "Certainly my favorite development tool, Visual Studio Code is, in my opinion, the perfect editor for developing any type of project. It is lightweight, fast, and highly extensible. I have almost always used Visual Studio Code to develop my projects, whether in C, Python, JavaScript, or other languages. The only exception is when I develop a Java project; I prefer to use Eclipse due to an old habit I picked up in middle school. I am quite familiar with Visual Studio Code and have used it in various situations, each more diverse than the last.",
        },
    },
    skLinux: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en Linux",
            text: "Au collège, durant ma découverte de l'informatique, j'ai aussi découvert Linux. À l'époque, Debian était la distribution la plus utilisée, c'est aussi avec cette distribution que j'ai découvert les joies de la ligne de commande. Depuis, j'ai souvent utilisé Linux pour développer des projets. Depuis le lycée, j'ai toujours un serveur avec Proxmox installé dessus, qui me permet de tester des projets et de m'entraîner à l'administration système. J'ai également plusieurs Raspberry Pi qui me permettent de lancer de plus petits projets. Globalement, je connais bien Linux, et je suis capable de l'utiliser dans de nombreuses situations.",
        },
        En: {
            title: "Skills in Linux",
            text: "In middle school, during my introduction to computer science, I also discovered Linux. At that time, Debian was the most widely used distribution, and it was with this distribution that I first experienced the joys of the command line. Since then, I have often used Linux to develop projects. Since high school, I have always had a server with Proxmox installed on it, which allows me to test projects and practice system administration. I also have several Raspberry Pis that enable me to run smaller projects. Overall, I am well-acquainted with Linux and can use it in many situations.",
        },
    },
    skTeamwork: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en Travail d'Équipe",
            text: "La quasi-totalité des projets réalisés durant mes études a été réalisée en équipe. J'ai donc acquis de nombreuses compétences en travail d'équipe, que ce soit pour la gestion de projet, la communication ou la collaboration. J'aime travailler en équipe, car cela permet de partager les idées et de trouver des solutions souvent meilleures que celles que l'on aurait pu trouver seul. Pour moi, il est important de confronter ses idées et de travailler avec d'autres personnes pour pouvoir trouver la solution la plus adaptée à un problème. En effet, on a tous des compétences, des expériences et des approches différentes, et c'est en les combinant que l'on peut trouver la meilleure solution.",
        },
        En: {
            title: "Skills in Teamwork",
            text: "Almost all the projects I completed during my studies were done in teams. Therefore, I have acquired many skills in teamwork, whether in project management, communication, or collaboration. I enjoy working in teams because it allows for the sharing of ideas and often leads to better solutions than one could find alone. For me, it is important to confront one's ideas and work with others to find the most suitable solution to a problem. Indeed, we all have different skills, experiences, and approaches, and it is by combining them that we can find the best solution.",
        },
    },
    skProblemSolving: {
        img: null,
        app: null,
        note: "xlim2023",
        Fr: {
            title: "Compétences en Résolution de Problèmes",
            text: "L'un de mes passe-temps préférés est de me poser des problèmes à résoudre. J'aime réfléchir au monde qui m'entoure, comprendre comment il fonctionne et réfléchir à des solutions à des problèmes qui n'existent pas forcément. Par exemple, en attendant à un arrêt de bus, je peux m'interroger sur la façon dont le réseau de bus est organisé, comment il pourrait être amélioré ou comment le logiciel qui affiche les horaires pourrait être changé pour éviter que des \"bus reculent\" ou deviennent des \"bus fantômes\". Et ce n'est qu'un exemple parmi tant d'autres. J'aime réfléchir à des problèmes complexes et trouver des solutions, pas seulement dans le domaine de l'informatique, mais aussi dans d'autres domaines. J'ai souvent utilisé cette compétence pour résoudre des problèmes complexes dans mes projets, ou dans le cadre de mes stages. Finalement, je pense pouvoir dire que si quelque chose me passionne plus que l'informatique, c'est peut-être la résolution de problèmes complexes. Que voulez-vous, j'aime m'arracher les cheveux sur des problèmes !",
        },
        En: {
            title: "Skills in Problem Solving",
            text: "One of my favorite pastimes is to challenge myself with problems to solve. I enjoy contemplating the world around me, understanding how it works, and thinking about solutions to problems that may not even exist. For example, while waiting at a bus stop, I might ponder how the bus network is organized, how it could be improved, or how the software displaying schedules could be modified to prevent 'buses reversing' or becoming 'ghost buses.' And that's just one example among many. I love thinking about complex problems and finding solutions, not only in the field of computer science but also in other areas. I have often used this skill to tackle complex issues in my projects or during my internships. Ultimately, I can say that if something excites me more than computer science, it might be solving complex problems. What can I say? I love pulling my hair out over challenges!",
        },
    },
    skReasearch: {
        img: null,
        app: null,
        note: "reasearchLab2024",
        Fr: {
            title: "Compétences en Recherche",
            text: "Le domaine que j'ai le plus côtoyé durant mes études est sans doute la recherche. Je ne compte plus les heures passées aux laboratoires de l'université, ou à lire des articles scientifiques. J'ai toujours été passionné par la recherche, et par les découvertes scientifiques. J'aime comprendre comment les choses fonctionnent, et comment on peut les améliorer. C'est pour cela que j'ai choisi un parcours universitaire. Pour moi, l'université est l'endroit de toutes les découvertes, de toutes les innovations et de toutes les avancées scientifiques. J'ai eu l'occasion de travailler sur de nombreux projets de recherche, tous mes stages ont été réalisés dans des laboratoires de recherche et j'ai toujours été passionné par les découvertes que j'ai pu y faire. J'ai également eu l'occasion d'assister à des conférences ou des séminaires, où j'ai pu découvrir les dernières avancées scientifiques dans de nombreux domaines.",
        },
        En: {
            title: "Skills in Research",
            text: "The field I have been most involved in during my studies is undoubtedly research. I have lost count of the hours spent in university laboratories or reading scientific articles. I have always been passionate about research and scientific discoveries. I enjoy understanding how things work and how they can be improved. That is why I chose an academic path. For me, the university is the place for all discoveries, innovations, and scientific advancements. I have had the opportunity to work on numerous research projects; all my internships were conducted in research laboratories, and I have always been fascinated by the discoveries I made there. I have also had the chance to attend conferences or seminars where I learned about the latest scientific advancements in various fields.",
        },
    },
    skExpermentation: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Compétences en Expérimentation",
            text: "Malgré mes forts liens avec les domaines de la recherche, je reste quelqu'un dans la technique. J'aime expérimenter, tester de nouvelles idées et de nouvelles approches. J'aime appliquer les théories que j'ai apprises. Je ne suis pas quelqu'un qui aime rester dans la théorie, pour moi, la théorie doit être appliquée pour être utile. C'est pour cela que j'aime expérimenter !",
        },
        En: {
            title: "Skills in Experimentation",
            text: "Despite my strong ties to research, I remain someone who is hands-on. I enjoy experimenting, testing new ideas and approaches. I like to apply the theories I have learned. I am not someone who likes to stay in theory; for me, theory must be applied to be useful. That is why I love experimenting!",
        },
    },
    skWhyThreePoints: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Pourquoi trois petits points ?",
            text: "J'ai choisi de mettre trois petits points à la fin de chaque compétence, car à l'université, nous n'apprenons pas à appliquer bêtement les compétences que l'on nous enseigne. Nous apprenons à réfléchir, à nous adapter, à trouver des solutions et à apprendre de nouvelles compétences qui ne sont pas forcément enseignées. Ces trois petits points représentent donc toutes les compétences acquises que je n'ai pas pu lister ici, mais aussi toutes celles que je pourrais acquérir rapidement pour satisfaire au mieux les besoins d'un projet futur.",
        },
        En: {
            title: "Why three dots?",
            text: "I chose to put three dots at the end of each skill, because at university, we are not taught to blindly apply the skills we learn. We learn to think, to adapt, to find solutions, and to learn new skills that are not necessarily taught. These three dots represent all the skills I have acquired that I couldn't list here, but also all the ones I could quickly acquire to best meet the needs of a future project.",
        },
    },
    lgFrench: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Langue maternelle",
            text: "Je suis originaire de Charente, un petit département rural de la région Nouvelle-Aquitaine, en France. Le français est donc ma langue maternelle, et je suis parfaitement à l'aise pour communiquer avec, que ce soit à l'oral ou à l'écrit.",
        },
        En: {
            title: "Native language",
            text: "I am from Charente, a small rural department in the Nouvelle-Aquitaine region of France. French is therefore my native language, and I am perfectly comfortable communicating in it, both orally and in writing.",
        },
    },
    lgEnglish: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Anglais",
            text: "Je ne peux pas dire que mon niveau d'anglais soit parfait, loin de là, mais je suis capable de communiquer avec des personnes anglophones. Je maîtrise plutôt bien l'anglais technique, ce qui me permet de lire des articles scientifiques ou de comprendre des documentations techniques. De plus, même si mon niveau peut parfois être limité, je cherche toujours à m'améliorer et à progresser dans cette langue. C'est pour cela que j'ai choisi de faire mes stages de L3, M1 et M2 à l'étranger, pour pouvoir pratiquer mon anglais au quotidien et améliorer mon niveau.",
        },
        En: {
            title: "English",
            text: "I cannot say that my English level is perfect, far from it, but I am able to communicate with English speakers. I have a good command of technical English, which allows me to read scientific articles or understand technical documentation. Moreover, even if my level can sometimes be limited, I always strive to improve and progress in this language. That is why I chose to do my internships in L3, M1, and M2 abroad, to be able to practice my English on a daily basis and improve my level.",
        },
    },
    hbDevelopment: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Développement de logiciels",
            text: "Sans surprise, le développement de logiciels est l'un de mes hobbies préférés. Depuis que j'ai commencé à programmer, j'ai toujours été passionné par le développement de logiciels. J'aime créer des applications, des jeux et des outils informatiques. Surtout ce que j'aime, c'est comprendre comment fonctionnent les logiciels, comment ils sont construits et comment on peut les améliorer et toujours repousser les limites de ce qui est possible. J'adore ce frisson de passer des heures à coder, puis appuyer sur le bouton 'Exécuter' et voir le résultat de son travail. C'est pour moi l'une des plus grandes satisfactions que l'on puisse avoir en tant que passionné d'informatique.",
        },
        En: {
            title: "Software Development",
            text: "Unsurprisingly, software development is one of my favorite hobbies. Since I started programming, I have always been passionate about software development. I enjoy creating applications, games, and computer tools. What I love most is understanding how software works, how it is built, and how we can improve it and always push the boundaries of what is possible. I love the thrill of spending hours coding, then pressing the 'Run' button and seeing the result of my work. For me, it is one of the greatest satisfactions one can have as a computer enthusiast.",
        },
    },
    hbMusic: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Musique",
            text: "Évidemment, un domaine que j'affectionne presque autant que l'informatique, c'est la musique. Je ne peux pas dire que je suis un excellent musicien, mais je fais de la batterie depuis que j'ai 9 ans. Lorsque j'étais au lycée, mon frère, d'autres amis et moi-même avons formé un groupe de musique, dans lequel je joue encore aujourd'hui. En plus de jouer, j'adore écouter de la musique, découvrir de nouveaux artistes ou de nouveaux genres musicaux, pour moi la musique est une source d'inspiration et de créativité. D'ailleurs, je suis quelqu'un qui adore écouter de la musique en travaillant, cela m'aide à me concentrer et à être plus productif.",
        },
        En: {
            title: "Music",
            text: "Of course, a field I cherish almost as much as computer science is music. I cannot say that I am an excellent musician, but I have been playing the drums since I was 9 years old. When I was in high school, my brother, some friends, and I formed a band, in which I still play today. Besides playing, I love listening to music, discovering new artists or musical genres; for me, music is a source of inspiration and creativity. By the way, I am someone who loves listening to music while working; it helps me concentrate and be more productive.",
        },
    },
    hbPhotography: {
        img: null,
        app: null,
        note: null,
        Fr: {
            title: "Photographie",
            text: "C'est une passion qui me suit depuis le collège, en comparaison aux deux précédentes, c'est la plus récente. J'adore la photographie, je suis un adepte de la lumière, de la composition. Mes sujets sont souvent inanimés et des objets du quotidien, mais j'adore trouver la lumière ou l'ombre qui permettra de les sublimer. J'ai d'ailleurs un compte Instagram où je publie régulièrement mes photos.",
        },
        En: {
            title: "Photography",
            text: "This is a passion that has followed me since middle school; compared to the previous two, it is the most recent. I love photography; I am an enthusiast of light and composition. My subjects are often inanimate and everyday objects, but I enjoy finding the light or shadow that will enhance them. I even have an Instagram account where I regularly post my photos.",
        },
    },
};

export function InteractiveCV(props) {
    const [note, setNote] = useState(null);
    const pageRef = useRef(null);

    const openNote = (ref) => (e) => {
        e.stopPropagation();
        if (note && note.ref === ref) {
            setNote(null);
        } else {
            setNote({
                ref: ref,
                x: e.clientX,
                y: e.clientY,
            });
        }
    };

    return (
        <Application {...props}>
            <div
                className={`interactive-cv_main`}
                onClick={() => {
                    setNote(null);
                }}
            >
                <ScaledA4
                    langage={props.language}
                    openNote={openNote}
                    openApp={props.openApp}
                    note={note}
                    pageRef={pageRef}
                />
            </div>
        </Application>
    );
}

export function InteractiveCVNote({
    langage,
    openApp,
    openNote,
    note,
    elementRef,
    scale,
}) {
    const { ref, x, y } = note;

    const [position, setPosition] = useState({ x: x, y: y });
    const [isOnTopPart, setIsOnTopPart] = useState(true);

    useEffect(() => {
        const rect = elementRef.current.getBoundingClientRect();

        const xTransformed = x - rect.left;
        const yTransformed = y - rect.top;

        const local = {
            x: xTransformed / scale,
            y: yTransformed / scale,
        };

        setIsOnTopPart(local.y < rect.height / scale / 2);

        setPosition({
            x: local.x,
            y: local.y,
        });
    }, [x, y, elementRef]);

    return (
        <div
            className="interactive-cv_note"
            onClick={(e) => {
                e.stopPropagation();
            }}
            style={{
                transform: `translate(-50%, ${
                    isOnTopPart ? "0%" : "-100%"
                }) translateY(${isOnTopPart ? "40px" : "-40px"})`,
                left: `${position.x}px`,
                top: `${position.y}px`,
            }}
        >
            <h2>{NOTES[ref][langage].title}</h2>
            {NOTES[ref].img && (
                <img src={NOTES[ref].img} alt={NOTES[ref][langage].title} />
            )}
            <div className="note-text">
                {Array.isArray(NOTES[ref][langage].text) ? (
                    NOTES[ref][langage].text.map((text, index) => (
                        <p key={index}>{text}</p>
                    ))
                ) : (
                    <p>{NOTES[ref][langage].text}</p>
                )}
            </div>
            {NOTES[ref].note && (
                <button onClick={openNote(NOTES[ref].note)}>
                    {langage === "Fr"
                        ? "Ouvrir la note suivante"
                        : "Open the next note"}
                </button>
            )}
            {NOTES[ref].app && (
                <button
                    onClick={() =>
                        openApp(NOTES[ref].app.command, NOTES[ref].app.args)
                    }
                >
                    {NOTES[ref].app.command == "pdf-viewer"
                        ? langage === "Fr"
                            ? "Ouvrir le PDF"
                            : "Open the PDF"
                        : NOTES[ref].app.command == "github"
                        ? langage === "Fr"
                            ? "Voir le profile GitHub"
                            : "View GitHub profile"
                        : langage === "Fr"
                        ? "Ouvrir l'application"
                        : "Open the application"}
                </button>
            )}
        </div>
    );
}

export default function ScaledA4({
    langage,
    openNote,
    openApp,
    note,
    pageRef,
    width = "100%",
    height = "100%",
}) {
    const wrapperRef = useRef(null);
    const [scale, setScale] = useState(1);

    useLayoutEffect(() => {
        if (!wrapperRef.current || !pageRef.current) return;
        const obs = new ResizeObserver((entries) => {
            for (let entry of entries) {
                const { width: W, height: H } = entry.contentRect;
                const tmp = document.createElement("div");
                tmp.style.width = "21cm";
                tmp.style.height = "29.7cm";
                tmp.style.visibility = "hidden";
                document.body.append(tmp);
                const pW = tmp.offsetWidth,
                    pH = tmp.offsetHeight;
                tmp.remove();

                const newScale = Math.min((W - 20) / pW, (H - 20) / pH);
                setScale(newScale);
            }
        });
        obs.observe(wrapperRef.current);
        return () => obs.disconnect();
    }, []);

    return (
        <div
            ref={wrapperRef}
            style={{
                width: width,
                height: height,
                overflow: "hidden",
            }}
            className="interactive-cv_wrapper"
        >
            <div
                ref={pageRef}
                className="page-container"
                style={{
                    transform: `scale(${scale}) translate(-50%, -50%) `,
                }}
            >
                {note && (
                    <InteractiveCVNote
                        langage={langage}
                        openApp={openApp}
                        openNote={openNote}
                        note={note}
                        elementRef={pageRef}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        scale={scale}
                    />
                )}
                <div className="page">
                    {langage == "Fr" ? (
                        <FrenchCV openNote={openNote} />
                    ) : (
                        <EnglishCV openNote={openNote} />
                    )}
                </div>
            </div>
        </div>
    );
}

export function FrenchCV({ openNote }) {
    return (
        <>
            <div className="panel-left"></div>
            <div className="panel-right">
                <div className="panel-right-top">
                    <h1 className="name">Tom BOIREAU</h1>
                </div>
                <div className="section panel-right-training">
                    <h2>Diplômes</h2>
                    <div className="job" onClick={openNote("master")}>
                        <div className="jobdates">
                            <h4 className="dates">2023 - Présent</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Master en Informatique -{" "}
                                <span>
                                    École Universitaire de Recherche, Software
                                    Design and Development
                                </span>
                            </h3>
                            <p>
                                Faculté des Sciences Fondamentales et
                                Appliquées, Université de Poitiers -{" "}
                                <i>Poitiers, Vienne, France</i>
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("licence")}>
                        <div className="jobdates">
                            <h4 className="dates">2023</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Licence en Informatique -{" "}
                                <span>
                                    Cursus Master en Ingénierie, mention Bien
                                </span>
                            </h3>
                            <p>
                                Faculté des Sciences Fondamentales et
                                Appliquées, Université de Poitiers -{" "}
                                <i>Poitiers, Vienne, France</i>
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("baccalaureat")}>
                        <div className="jobdates">
                            <h4 className="dates">2020</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Baccalauréat général Scientifique -{" "}
                                <span>Spécialité physique, mention Bien</span>
                            </h3>
                            <p>
                                Lycée de l'Image et du Son d'Angoulême -{" "}
                                <i>Angoulême, Charente, France</i>
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("bia")}>
                        <div className="jobdates">
                            <h4 className="dates">2017</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>Brevet d'Initiation à l'Aéronautique</h3>
                            <p>
                                Aéroclub d'Angoulême -{" "}
                                <i>Champniers, Charente, France</i>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="section panel-right-prœxp">
                    <h2>Expériences Professionnelles</h2>
                    <div className="job" onClick={openNote("glasgow2025")}>
                        <div className="jobdates">
                            <h4 className="dates">2025 - En cours</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Stage de recherche en Machine Learning -{" "}
                                <span>
                                    University of Glasgow -{" "}
                                    <i>Glasgow, Écosse</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Fine-tuning et modification du modèle Llama 3.2
                                1B pour la reconnaissance des émotions.
                                <br />
                                Stage encadré par le Pr. Jose Jœmon (GAIR-Lab).
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("glasgow2024")}>
                        <div className="jobdates">
                            <h4 className="dates">2024 - 2 mois</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Stage de recherche en Machine Learning /
                                Parallélisation -{" "}
                                <span>
                                    University of Glasgow -{" "}
                                    <i>Glasgow, Écosse</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Développement d'un pipeline modulaire
                                multithreadé pour la reconnaissance des
                                émotions.
                                <br />
                                Stage encadré par le Pr. Jose Jœmon (GAIR-Lab).
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("reasearchLab2024")}>
                        <div className="jobdates">
                            <h4 className="dates">2024 - 2 semestres</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Projet en collaboration avec un doctorant -{" "}
                                <span>
                                    University de Poitiers -{" "}
                                    <i>Poitiers, Vienne, France</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Projet d'un an sur la reconstruction des
                                G-cartes, en collaboration avec Maxime GAIDE.
                                <br />
                                Projet encadré par le Dr Agnès Arnould (XLIM).
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("shibpur2023")}>
                        <div className="jobdates">
                            <h4 className="dates">2023 - 3 mois</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Stage de recherche en Informatique -{" "}
                                <span>
                                    IIEST Shibpur -{" "}
                                    <i>Kolkata, West Bengal, Inde</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Conception de modèles de deep learning pour
                                détecter les paramètres des droites discrètes.
                                <br />
                                Stage encadré par le Pr. Arindam BISWAS (IIEST)
                                et le Pr. Eric ANDRES (XLIM).
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("xlim2023")}>
                        <div className="jobdates">
                            <h4 className="dates">2023 - 1 semestre</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Projet en laboratoire -{" "}
                                <span>
                                    XLIM - <i>Poitiers, Vienne, France</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Développement d'un algorithme de détection des
                                similarités dans des images.
                                <br />
                                Projet encadré par le Dr Thierry URRUTY (XLIM)
                                et la société Einden.
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("xlim2022")}>
                        <div className="jobdates">
                            <h4 className="dates">2022 - 1 mois</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Stage en laboratoire -{" "}
                                <span>
                                    XLIM - <i>Poitiers, Vienne, France</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Programmation d'un robot pour lui apprendre à
                                reconnaître son environnement.
                                <br />
                                Stage encadré par le Dr Thierry URRUTY (XLIM).
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("nexeya2019")}>
                        <div className="jobdates">
                            <h4 className="dates">2019 - 1 semaine</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Stage de découverte en ingénierie -{" "}
                                <span>
                                    Nexeya France -{" "}
                                    <i>La Couronne, Charente, France</i>
                                </span>
                            </h3>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("imagine2016")}>
                        <div className="jobdates">
                            <h4 className="dates">2016 - 1 semaine</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Stage de découverte en électronique -{" "}
                                <span>
                                    Imagine et Son -{" "}
                                    <i>Angoulême, Charente, France</i>
                                </span>
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="section panel-right-skills">
                    <h2>Compétences</h2>
                    <h3>
                        Développement :{" "}
                        <b onClick={openNote("skDeepLearning")}>
                            Deep Learning
                        </b>
                        ,{" "}
                        <b onClick={openNote("skParallelization")}>
                            Parallélisation
                        </b>
                        , <b onClick={openNote("skLowLevel")}>Bas-niveau</b>,{" "}
                        <b onClick={openNote("sk3DAlgorithms")}>
                            Algorithmie 3D
                        </b>
                        , <b>...</b>
                    </h3>
                    <h3>
                        Langages de programmation :{" "}
                        <b onClick={openNote("skCCpp")}>C/C++</b>,{" "}
                        <b onClick={openNote("skPython")}>Python</b>,{" "}
                        <b onClick={openNote("skJava")}>Java</b>,{" "}
                        <b onClick={openNote("skJavaScript")}>JavaScript</b>,{" "}
                        <b onClick={openNote("skOcaml")}>Ocaml</b>,{" "}
                        <b onClick={openNote("skCSharp")}>C#</b>,{" "}
                        <b onClick={openNote("skACSL")}>ACSL</b>,{" "}
                        <b onClick={openNote("skCoq")}>Coq</b>, <b>...</b>
                    </h3>
                    <h3>
                        Outils : <b onClick={openNote("skGit")}>Git</b>,{" "}
                        <b onClick={openNote("skLatex")}>LaTeX</b>,{" "}
                        <b onClick={openNote("skCUDA")}>CUDA</b>,{" "}
                        <b onClick={openNote("skOpenGL")}>OpenGL</b>,{" "}
                        <b onClick={openNote("skNodeJS")}>Node.js</b>,{" "}
                        <b onClick={openNote("skUnity")}>Unity</b>,{" "}
                        <b onClick={openNote("skBlender")}>Blender</b>,{" "}
                        <b onClick={openNote("skVSCode")}>VS Code</b>,{" "}
                        <b onClick={openNote("skLinux")}>Linux</b>, <b>...</b>
                    </h3>
                    <h3>
                        Autres :{" "}
                        <b onClick={openNote("skTeamwork")}>
                            Travail en équipe
                        </b>
                        ,{" "}
                        <b onClick={openNote("skProblemSolving")}>
                            Résolution de problèmes
                        </b>
                        , <b onClick={openNote("skReasearch")}>Recherche</b>,{" "}
                        <b onClick={openNote("skExpermentation")}>
                            Expérimentations
                        </b>
                        , <b>...</b>
                    </h3>
                </div>
                <div className="section panel-right-lang">
                    <h2>Langues</h2>
                    <h3 onClick={openNote("lgFrench")}>
                        <b>Français :</b> Langue maternelle
                    </h3>
                    <h3 onClick={openNote("lgEnglish")}>
                        <b>Anglais :</b> Niveau B2
                    </h3>
                </div>
                <div className="section panel-right-hobbies">
                    <h2>Hobbies</h2>
                    <h3 onClick={openNote("hbDevelopment")}>
                        <b>Développement :</b> La programmation est une passion
                        pour moi depuis l'âge de 11 ans.
                    </h3>
                    <h3 onClick={openNote("hbMusic")}>
                        <b>Musique :</b> Batteur depuis l'âge de 9 ans, dans un
                        groupe de musique.
                    </h3>
                    <h3 onClick={openNote("hbPhotography")}>
                        <b>Photographie et vidéo :</b> Passionné par la capture
                        et l'édition d'images.
                    </h3>
                </div>
            </div>
        </>
    );
}

export function EnglishCV({ openNote }) {
    return (
        <>
            <div className="panel-left"></div>
            <div className="panel-right">
                <div className="panel-right-top">
                    <h1 className="name">Tom BOIREAU</h1>
                </div>
                <div className="section panel-right-training">
                    <h2>Education</h2>
                    <div className="job" onClick={openNote("master")}>
                        <div className="jobdates">
                            <h4 className="dates">2023 - Present</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Master in Computer Science -{" "}
                                <span>
                                    Selective research master's program,
                                    Software Design and Development
                                </span>
                            </h3>
                            <p>
                                Faculty of Applied Fundamental Science,
                                University of Poitiers - <i>Poitiers, France</i>
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("licence")}>
                        <div className="jobdates">
                            <h4 className="dates">2023</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Bachelor of Computer Science -{" "}
                                <span>
                                    Selective program in engineering, obtained
                                    with honours
                                </span>
                            </h3>
                            <p>
                                Faculty of Applied Fundamental Science,
                                University of Poitiers - <i>Poitiers, France</i>
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("baccalaureat")}>
                        <div className="jobdates">
                            <h4 className="dates">2020</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Science Baccalaureat -{" "}
                                <span>
                                    Equivalent to British A-levels, obtained
                                    with honours
                                </span>
                            </h3>
                            <p>
                                High school of Image and Sound -{" "}
                                <i>Angoulême, France</i>
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("bia")}>
                        <div className="jobdates">
                            <h4 className="dates">2017</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>Aeornautical initiation certificate</h3>
                            <p>
                                Flying club of Angoulême -{" "}
                                <i>Champniers, France</i>
                            </p>
                        </div>
                    </div>
                </div>
                <div className="section panel-right-prœxp">
                    <h2>Work History</h2>
                    <div className="job" onClick={openNote("glasgow2025")}>
                        <div className="jobdates">
                            <h4 className="dates">2025 - In preparation</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Internship in Machine Learning Reasearch -{" "}
                                <span>
                                    University of Glasgow -{" "}
                                    <i>Glasgow, United-Kingdom</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Refined and optimized the Llama model for
                                emotion recognition.
                                <br />
                                Internship supervised by Pr. Jose Jœmon
                                (GAIR-Lab).
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("glasgow2024")}>
                        <div className="jobdates">
                            <h4 className="dates">2024 - 2 months</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Internship in Computer Science Reasearch -{" "}
                                <span>
                                    University of Glasgow -{" "}
                                    <i>Glasgow, United-Kingdom</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Developed a modular pipeline multithreaded for
                                multimodal emotion recognition.
                                <br />
                                Internship supervised by Pr. Jose JOEMON
                                (GAIR-Lab)
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("reasearchLab2024")}>
                        <div className="jobdates">
                            <h4 className="dates">2024 - 2 semesters</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Project in collaboration with a PhD student -{" "}
                                <span>
                                    University of Poitiers -{" "}
                                    <i>Poitiers, France</i>
                                </span>
                            </h3>
                            <p className="desc">
                                One-year research project on G-map modelling, in
                                collaboration with Maxime GAIDE.
                                <br />
                                Project supervised by Dr. Agnès Arnould (XLIM)
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("shibpur2023")}>
                        <div className="jobdates">
                            <h4 className="dates">2023 - 3 months</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Internship in Machine Learning Reasearch -{" "}
                                <span>
                                    IIEST Shibpur - <i>Kolkata, India</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Developed deep learning models to detect
                                straight lines parameters in an image.
                                <br />
                                Internship supervised by Pr. Arindam BISWAS
                                (IIEST) and Pr. Eric ANDRES (XLIM)
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("xlim2023")}>
                        <div className="jobdates">
                            <h4 className="dates">2023 - 1 semester</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Project with a laboratory -{" "}
                                <span>
                                    XLIM - <i>Poitiers, France</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Developed an algorithm for detecting similar
                                images.
                                <br />
                                Project supervised by Dr. Thierry URRUTY (XLIM)
                                and by the Einden company.
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("xlim2022")}>
                        <div className="jobdates">
                            <h4 className="dates">2022 - 1 month</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Internship with a laboratory -{" "}
                                <span>
                                    XLIM - <i>Poitiers, France</i>
                                </span>
                            </h3>
                            <p className="desc">
                                Programmed a robot to teach it to recognize its
                                environment.
                                <br />
                                Internship supervised by Dr. Thierry URRUTY
                                (XLIM).
                            </p>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("nexeya2019")}>
                        <div className="jobdates">
                            <h4 className="dates">2019 - 1 week</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Internship in engineering -{" "}
                                <span>
                                    Nexeya France - <i>La Couronne, France</i>
                                </span>
                            </h3>
                        </div>
                    </div>
                    <div className="job" onClick={openNote("imagine2016")}>
                        <div className="jobdates">
                            <h4 className="dates">2016 - 1 week</h4>
                        </div>
                        <div className="jobdesc">
                            <h3>
                                Internship in electronics -{" "}
                                <span>
                                    Imagine et Son - <i>Angoulême, France</i>
                                </span>
                            </h3>
                        </div>
                    </div>
                </div>
                <div className="section panel-right-skills">
                    <h2>Skills</h2>
                    <h3>
                        Development:{" "}
                        <b onClick={openNote("skDeepLearning")}>
                            Deep Learning
                        </b>
                        ,{" "}
                        <b onClick={openNote("skParallelization")}>
                            Parallelization
                        </b>
                        ,{" "}
                        <b onClick={openNote("skLowLevel")}>
                            Low-level Programming
                        </b>
                        ,{" "}
                        <b onClick={openNote("sk3DAlgorithms")}>
                            3D Algorithms
                        </b>
                        , <b onClick={openNote("skWhyThreeDots")}>...</b>
                    </h3>
                    <h3>
                        Programming languages:{" "}
                        <b onClick={openNote("skCCpp")}>C/C++</b>,{" "}
                        <b onClick={openNote("skPython")}>Python</b>,{" "}
                        <b onClick={openNote("skJava")}>Java</b>,{" "}
                        <b onClick={openNote("skJavaScript")}>JavaScript</b>,{" "}
                        <b onClick={openNote("skOcaml")}>Ocaml</b>,{" "}
                        <b onClick={openNote("skCSharp")}>C#</b>,{" "}
                        <b onClick={openNote("skACSL")}>ACSL</b>,{" "}
                        <b onClick={openNote("skCoq")}>Coq</b>,{" "}
                        <b onClick={openNote("skWhyThreePoints")}>...</b>
                    </h3>
                    <h3>
                        Tools: <b onClick={openNote("skGit")}>Git</b>,{" "}
                        <b onClick={openNote("skLatex")}>LaTeX</b>,{" "}
                        <b onClick={openNote("skCUDA")}>CUDA</b>,{" "}
                        <b onClick={openNote("skOpenGL")}>OpenGL</b>,{" "}
                        <b onClick={openNote("skNodeJS")}>Node.js</b>,{" "}
                        <b onClick={openNote("skUnity")}>Unity</b>,{" "}
                        <b onClick={openNote("skBlender")}>Blender</b>,{" "}
                        <b onClick={openNote("skVSCode")}>VS Code</b>,{" "}
                        <b onClick={openNote("skLinux")}>Linux</b>,{" "}
                        <b onClick={openNote("skWhyThreeDots")}>...</b>
                    </h3>
                    <h3>
                        Others: <b onClick={openNote("skTeamwork")}>Teamwork</b>
                        ,{" "}
                        <b onClick={openNote("skProblemSolving")}>
                            Problem solving
                        </b>
                        , <b onClick={openNote("skReasearch")}>Research</b>,{" "}
                        <b onClick={openNote("skExpermentation")}>
                            Experimentations
                        </b>
                        , <b onClick={openNote("skWhyThreeDots")}>...</b>
                    </h3>
                </div>
                <div className="section panel-right-lang">
                    <h2>Languages</h2>
                    <h3 onClick={openNote("lgFrench")}>
                        <b>French:</b> Native
                    </h3>
                    <h3 onClick={openNote("lgEnglish")}>
                        <b>English:</b> Intermediate Level
                    </h3>
                </div>
                <div className="section panel-right-hobbies">
                    <h2>Hobbies</h2>
                    <h3 onClick={openNote("hbDevelopment")}>
                        <b>Programming:</b> Developing my programming skills
                        since the age of 11.
                    </h3>
                    <h3 onClick={openNote("hbMusic")}>
                        <b>Music:</b> Drummer, since the age of 9, in a music
                        group.
                    </h3>
                    <h3 onClick={openNote("hbPhotography")}>
                        <b>Photography and video:</b> Passionate about image
                        capture and editing.
                    </h3>
                </div>
            </div>
        </>
    );
}
